import { hero } from '../data';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

export default function Hero() {
  return (
    <section
      className="relative h-[50vh] flex items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: `url(${hero.backgroundImage})` }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-4">
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
          {hero.headline}
        </h1>
        <p className="text-lg md:text-xl text-gray-200 mb-8 max-w-2xl mx-auto">
          {hero.tagline}
        </p>
        <a
          href={hero.ctaLink}
          className="inline-flex items-center bg-brandBlue text-white px-6 py-3 rounded-md font-medium hover:bg-blue-800 transition duration-300"
        >
          {hero.ctaText}
          <ChevronDownIcon className="w-5 h-5 ml-2 animate-bounce" />
        </a>
      </div>
    </section>
  );
}